const todoStatusIconMap = {
  'follow-up': 'TodoFollowUp',
  other: 'TodoOther',
  consultation: 'TodoConsultation',
  complete: 'TodoComplete',
  call: 'PhoneCall',
  reminder: 'Clock',
  alert: 'TodoAlert',
  scheduled: 'Calendar',
  appointment: 'Calendar',
  'in-person-meeting': 'TodoInPersonMeeting',
};

export default todoStatusIconMap;
